const isSameCalendarDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const formatRelativeTime = (date) => {
  const itemDate = new Date(date);
  const now = new Date();
  const diffMs = now - itemDate;

  if (isSameCalendarDay(itemDate, now)) {
    if (diffMs < 60_000) return 'Just now';
    if (diffMs < 3_600_000) {
      const minutes = Math.max(1, Math.floor(diffMs / 60_000));
      return `${minutes} min ago`;
    }
    const hours = Math.floor(diffMs / 3_600_000);
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  }

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (isSameCalendarDay(itemDate, yesterday)) return 'Yesterday';

  return itemDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
